import { render, staticRenderFns } from "./documents-section.vue?vue&type=template&id=2725b2f2&scoped=true"
import script from "./documents-section.vue?vue&type=script&lang=ts"
export * from "./documents-section.vue?vue&type=script&lang=ts"
import style0 from "./documents-section.vue?vue&type=style&index=0&id=2725b2f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2725b2f2",
  null
  
)

export default component.exports